import React from "react";
import { i18n } from "../../translate/i18n";

/**
 * Estado vazio da lista de conversas (modo Tailwick).
 */
export default function ChatListEmptyState({
	title = i18n.t("ticketsList.noTicketsTitle"),
	message = i18n.t("ticketsList.noTicketsMessage"),
}) {
	return (
		<div className="flex flex-col items-center justify-center px-5 py-16 text-center">
			<div className="mb-4 flex size-14 items-center justify-center rounded-full bg-default-150 text-default-500">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="text-default-500"
					aria-hidden
				>
					<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
				</svg>
			</div>
			<h6 className="card-title mb-1 text-sm">{title}</h6>
			<p className="max-w-[14rem] text-xs leading-relaxed text-default-500">{message}</p>
		</div>
	);
}
